import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { fetchQuestionTestById } from 'app/actions/TestActions';

import { getTestQuestion, getIsLoadingTestQuestion } from 'app/reducers';
import isEmpty from 'app/utils/IsEmpty';

export default function EditQuestionContainer(props){

    let testQuestion = useSelector(getTestQuestion);
    let isLoading = useSelector(getIsLoadingTestQuestion);
    const dispatch = useDispatch();
    // const testData = props.filterData
    
    useEffect(() => {
        if (isEmpty(testQuestion)) fetchTestQuestionAction();
    }, []);

    const fetchTestQuestionAction = () => dispatch(fetchQuestionTestById(props.filterData.idTest))
    const testQuestions= testQuestion.map((param, i) => {
        const activeKey = {activeKey: {isActive: false, key: i}};
        Object.assign(param, activeKey)
        return param;
    })
    return (props.children({ testQuestions, isLoading}));
}